import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumberInput]'
})
export class OnlyNumberInputDirective {

  private _exceptionalCharacters: string[] = [];
  @Input() set exceptionalCharacters(characters: string[]) {
    this._exceptionalCharacters = characters;
    const auxRegex = this._exceptionalCharacters.map(c => c === ',' ? '\\,' : c).join('');
    this.regex = new RegExp(`^(([0-9${auxRegex}])*){0,1}$`, 'g');
  }
  get exceptionalCharacters(): string[] {
    return this._exceptionalCharacters;
  }

  private regex: RegExp = new RegExp(/^([0-9]*){0,1}$/g);

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];
  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  @HostListener('paste', ['$event'])
  onKeyDown(event: KeyboardEvent | ClipboardEvent) {
    if (event.type === 'keydown') {
      this.manageKeyDown(<KeyboardEvent>event);
    }
    if (event.type === 'paste') {
      this.managePaste(<ClipboardEvent>event);
    }
  }

  manageKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) < 0) {
      const current: string = this.el.nativeElement.value;
      const next: string = current.concat(event.key);
      if (next && !String(next).match(this.regex) && !(event.ctrlKey && (event.key === 'v' || event.key === 'c'))) {
        event.preventDefault();
      }
    }
  }

  managePaste(event: ClipboardEvent) {
    let text: string;
    if ((<any>window).clipboardData && (<any>window).clipboardData.getData) { // IE
      text = (<any>window).clipboardData.getData('Text');
    } else if (event.clipboardData && event.clipboardData.getData) {
      text = event.clipboardData.getData('text/plain');
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(text);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  private containsChars(text: string, chars: string[]): boolean {

    return true;
  }

}
